const webSettingRouter = {
  path: '/website',
  component: () => import('@/views/cms/websetting/index'), // Parent router-view
  name: 'MetaInfo',
  meta: {
    title: '元信息管理',
    icon: 'el-icon-postcard',
    roles: ['root']
  },
  children: [
    {
      path: 'minip_meta_info',
      name: 'MetaInfo',
      component: () => import('@/views/minip/websetting/meta_info'),
      meta: { title: '小程序基本信息', icon: 'el-icon-postcard', roles: ['root'], noCache: false }
    },
    {
      path: 'websetting',
      name: 'WebSetting',
      component: () => import('@/views/cms/websetting/meta_info'),
      meta: { title: '官网基本信息', icon: 'el-icon-postcard', roles: ['root'], noCache: false }
    },
    {
      path: 'table',
      name: 'MetaInfoTable',
      component: () => import('@/views/minip/websetting/meta_table'),
      meta: { title: '元信息列表', icon: 'el-icon-menu', roles: ['root'], noCache: true }
    }
  ]
}
export default webSettingRouter
